window.dataLayer = window.dataLayer || [];
window.dataLayer.push( { 'gtm.start': new Date().getTime(), event: 'gtm.js' } );
const gtmScript = document.createElement( 'script' );
gtmScript.async = true;
gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
document.head.appendChild( gtmScript );
